<template>
  <div class="w-100">
    New Appointment added, Tech
    <user-object
      :entity-id="appointmentTechnicianId()"
      :name="appointmentTechnicianName()"
      :open-new="true"
    />
    <br />

    <template v-if="appointmentAssistants().length">
      Assistants:
      <user-object
        v-for="assistant in appointmentAssistants()"
        :key="`assistant-${assistant.id}`"
        :entity-id="assistant.id"
        :icon="['fal', 'user']"
        :name="assistant.name"
        :open-new="true"
        class="mr-1"
        color="opacity-75 badge-pill badge-secondary"
      />
      <br />
    </template>

    {{ appointmentTime() }}
    for {{ appointmentDuration() }}

    <appointment-object :appointment-number="appointmentNumber()" />

    <generic-object v-if="$lodash.has(activity, 'detail.appointment.state')" class="ml-1">
      {{ activity.detail.appointment.state }}
    </generic-object>

    <notes-object
      v-if="$lodash.has(activity, 'detail.appointment.notes')"
      class="ml-1"
      :tooltip="activity.detail.appointment.notes"
    />
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
